import React, { Fragment } from 'react';

const ChaiFooter = () => <Fragment>Chai Admin ©2019</Fragment>;

export default ChaiFooter;
